<template>
<div class="relative">
  <div class="vx-navbar-wrapper navbar-full p-0">
    <vs-navbar
      class="navbar-custom navbar-skelton"
      :class="navbarClasses"
      :style="navbarStyle"
      :color="navbarColor"
    >

      <router-link tag="div" to="/" class="vx-logo cursor-pointer mx-auto flex items-center">
        <img
          class="mr-4 fill-current text-primary"
          src="@/assets/images/logo/logo.png"
        />
<!--        <logo class="mr-4 fill-current text-primary" />-->
      </router-link>

      <back-original-user v-if="!isOriginalUser" />

      <!-- <i18n /> -->

<!--      <search-bar />-->

<!--      <notification-drop-down />-->

      <profile-drop-down />

    </vs-navbar>
  </div>
</div>
</template>

<script>
  import Logo                 from "../Logo.vue"
  // import I18n                 from "./components/I18n.vue"
  import SearchBar            from "./components/SearchBar.vue"
  import ProfileDropDown      from "./components/ProfileDropDown.vue"
  import BackOriginalUser     from "./components/BackOriginalUser.vue"
  import NotificationDropDown from "./components/NotificationDropDown.vue"

  import moduleUser from '@/store/user/moduleUser.js'

  export default {
    name: "the-navbar-horizontal",
    props: {
      logo: { type: String },
      navbarType: {
        type: String,
        required: true
      }
    },
    components: {
      Logo,
      // I18n,
      SearchBar,
      ProfileDropDown,
      BackOriginalUser,
      NotificationDropDown
    },
    created() {
      if(!moduleUser.isRegistered) {
        this.$store.registerModule('user', moduleUser)
        moduleUser.isRegistered = true
      }
    },
    computed: {
      navbarColor() {
        let color = "#fff"
        if (this.navbarType === "sticky") {
          color = "#f7f7f7"
        } else if (this.navbarType === 'static') {
          if (this.scrollY < 50) {
            color = "#f7f7f7"
          }
        }

        this.isThemeDark === "dark" ? color === "#fff" ? color = "#10163a" : color = "#262c49" : null

        return color
      },
      isThemeDark() {
        return this.$store.state.theme
      },
      navbarStyle() {
        return this.navbarType === "static" ? {transition: "all .25s ease-in-out"} : {}
      },
      navbarClasses() {
        return this.scrollY > 5 && this.navbarType === "static" ? null : "d-theme-dark-light-bg shadow-none"
      },
      scrollY() {
        return this.$store.state.scrollY
      },
      verticalNavMenuWidth() {
        return this.$store.state.verticalNavMenuWidth
      },
      windowWidth() {
        return this.$store.state.windowWidth
      },
      isOriginalUser() {
        return this.$store.state.user.isOriginalUser
      }
    }
  }
</script>
